import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaTrash, FaCheck, FaTimes, FaSearch, FaEraser, FaEye } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Paginacao from '../../common/pagination';
import { formatarValor, formatarValorAPI, hasPerm } from "../../common/utils";
import AsyncSelect from "react-select/async";

class ProgramaServicoProcedimento extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listServicoProcedimento: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            filtro_servico_procedimento: '',

            // Modal
            showModal: false,
            modalTitulo: '',
            
            // Campos do formulário
            id: null,
            status: true,
            valor: '', 
            limite_por_cpf: "", 
            servico_procedimento_id: '', 
            servico_procedimento_nome: '', 
            estados_selecionados: {},      
            estados_register: [],   
            show: false, 
            limite_observacao: '', 
            permite_ultrapassar_limite: false, 
            lembrete_dia_anterior: false, 
            template_whatsapp_prestador: '', 
            template_whatsapp_paciente: '', 
            limite_reagendamentos: '', 
            limite_periodo: '',
            
        };
    }

    componentDidMount() {
        this.carregarServicoProcedimento(this.state.page_numb);
    }

    carregarServicoProcedimento = (page_numb = 1) => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        let url = `/programas/servicos_procedimentos/?programa=${programaId}&status=1&page=${page_numb}`;

        if (this.state.filtro_servico_procedimento) {
            url += `&servico_procedimento=${encodeURIComponent(this.state.filtro_servico_procedimento)}`;
        }

        api.get(url)
        .then(response => {
            const results = response.data.results.map(servico => ({
                ...servico,
                estados_selecionados: this.mapEstadosSelecionados(servico.estados_list),
                estados_register: servico.estados_list
            }));

                    this.setState({
                listServicoProcedimento: {
                    ...response.data,
                    results
                },
                loading: false
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao carregar serviços do programa';

            if (error.response?.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }

            this.setState({
                loading: false,
                error: erro_msg,
            });
        });
    };


    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });

        this.carregarServicoProcedimento(num_page);
    }

    filtrarServico = (e) => {
        e.preventDefault();
        this.setState({ page_numb: 1 }, () => this.carregarServicoProcedimento(1));
    };

    limpaFiltro = () => {
        this.setState(
            { filtro_servico_procedimento: '', page_numb: 1 },
            () => this.carregarServicoProcedimento(1)
        );
    };

    abrirModalNovo = () => {
        this.setState({
            showModal: true,
            modalTitulo: 'Adicionar Serviço Procedimento',
            id: null,
            valor: '',
            limite_por_cpf: "",
            servico_procedimento_id: '',
            servico_procedimento_nome: '',
            estados_selecionados: {},
            estados_register: [],
            limite_observacao: '',
            permite_ultrapassar_limite: false,
            lembrete_dia_anterior: false,
            template_whatsapp_prestador: '',
            template_whatsapp_paciente: '',
            limite_reagendamentos: '',
            limite_periodo: '',
        });
    };

    abrirModalEditar = (item) => {
        this.setState({
            showModal: true,
            modalTitulo: 'Editar Serviço Procedimento',
            id: item.id,
            valor: formatarValor(item.valor),
            limite_por_cpf: item.limite_por_cpf,
            servico_procedimento_id: item.servico_procedimento_id,
            servico_procedimento_nome: item.dados_servico.nome,
            estados_register: item.estados_register || item.estados_list || [],
            estados_selecionados: item.estados_selecionados || {},
            limite_observacao: item.limite_observacao || '',
            permite_ultrapassar_limite: !!item.permite_ultrapassar_limite,
            lembrete_dia_anterior: !!item.lembrete_dia_anterior,
            template_whatsapp_prestador: item.template_whatsapp_prestador || '',
            template_whatsapp_paciente: item.template_whatsapp_paciente || '',
            limite_reagendamentos: item.limite_reagendamentos || '',
            limite_periodo: item.limite_periodo || '',
        });
    };

    fecharModal = () => {
        this.setState({
            showModal: false,
            id: null,
            valor: '',
            limite_por_cpf: "",
            servico_procedimento_id: '',
            servico_procedimento_nome: '',
            estados_selecionados: {},
            estados_register: [],
            limite_observacao: '',
            permite_ultrapassar_limite: false,
            lembrete_dia_anterior: false,
            template_whatsapp_prestador: '',
            template_whatsapp_paciente: '',
            limite_reagendamentos: '',
            limite_periodo: '',
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, [`${name}Error`]: '' });
    };

    salvarServicoProcedimento = async () => {
        const { programaId } = this.props;

        const dados = {
            programa_id: programaId,
            status: true,
            valor: this.state.valor ? formatarValorAPI(this.state.valor) : 0,
            servico_procedimento_id: this.state.servico_procedimento_id,
            limite_observacao: this.state.limite_observacao,
            permite_ultrapassar_limite: this.state.permite_ultrapassar_limite,
            lembrete_dia_anterior: this.state.lembrete_dia_anterior,
            template_whatsapp_prestador: this.state.template_whatsapp_prestador,
            template_whatsapp_paciente: this.state.template_whatsapp_paciente,
            estados_register: this.state.estados_register
        };

        if (this.state.limite_por_cpf) {
            dados.limite_por_cpf = this.state.limite_por_cpf;
        }

        if (this.state.limite_reagendamentos) {
            dados.limite_reagendamentos = this.state.limite_reagendamentos;
        }

        if (this.state.limite_periodo) {
            dados.limite_periodo = this.state.limite_periodo;
        }

        const url = this.state.id ? `/programas/servicos_procedimentos/${this.state.id}/` : '/programas/servicos_procedimentos/';
        const metodo = this.state.id ? 'put' : 'post';

        this.setState({ loadingModal: true });

        try {
            await api({ method: metodo, url, data: dados });

            Swal.fire('Sucesso', 'Serviço/Procedimento salvo com sucesso', 'success');

            this.fecharModal();
            this.carregarServicoProcedimento(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao cadastrar o serviço, verifique os campos e tente novamente';
            let content = '';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data || {};

                for (let key in campos) {
                    const value = campos[key];

                    if (key === 'servico_procedimento_id') {
                        content += `<br>&bull; Serviço/Procedimento: ${value}`;
                    }
                    if (key === 'valor') {
                        content += `<br>&bull; Valor: ${value}`;
                    }
                    if (key === 'limite_por_cpf') {
                        content += `<br>&bull; Limite por CPF: ${value}`;
                    }
                    if (key === 'limite_reagendamentos') {
                        content += `<br>&bull; Limite Reagendamentos: ${value}`;
                    }
                    if (key === 'limite_periodo') {
                        content += `<br>&bull; Limite Período: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: erro_msg,
                html: content,
            });
        } finally {
            this.setState({ loadingModal: false });
        }
    };

    excluir = (item) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Remover serviço?',
            text: 'Tem certeza que deseja remover este serviço/procedimento?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (!result.isConfirmed) return;

            try {
                await api.put(
                    `/programas/servicos_procedimentos/${item.id}/`,
                    { status: false }
                );

                MySwal.fire({
                    title: 'Serviço removido com sucesso',
                    icon: 'success',
                    showCloseButton: true,
                });

                // Recarrega a listagem atual
                this.carregarServicoProcedimento(this.state.page_numb);

            } catch (error) {
                let erro_msg = 'Erro ao remover o serviço, tente novamente';

                if (error.response?.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                }

                MySwal.fire({
                    icon: 'error',
                    showCloseButton: true,
                    title: erro_msg,
                });
            }
        });
    };

    carregarServicos = async (inputValue) => {
        const { programaId } = this.props;

        try {
            const responsePrograma = await api.get(`/programas/servicos_procedimentos/?programa=${programaId}&status=1`);
            const idsJaUsados = responsePrograma.data.results.map(s => s.servico_procedimento_id);
            const responseTodos = await api.get(`/servicos_procedimentos/?nome=${inputValue}&status=1`);

            return responseTodos.data.results
                .filter(servico => !idsJaUsados.includes(servico.id))
                .map(servico => ({
                    value: servico.id,
                    label: `${servico.nome} (#${servico.id})`,
                    valor: servico.valor
                }));

        } catch (error) {
            console.error('Erro ao carregar serviços/procedimentos:', error);
            return [];
        }
    };

    mapEstadosSelecionados = (estados_list = []) => {
        const estadosBrasileiros = [
            { value: 'AC', label: 'Acre' },
            { value: 'AL', label: 'Alagoas' },
            { value: 'AM', label: 'Amazonas' },
            { value: 'AP', label: 'Amapá' },
            { value: 'BA', label: 'Bahia' },
            { value: 'CE', label: 'Ceará' },
            { value: 'DF', label: 'Distrito Federal' },
            { value: 'ES', label: 'Espírito Santo' },
            { value: 'GO', label: 'Goiás' },
            { value: 'MA', label: 'Maranhão' },
            { value: 'MT', label: 'Mato Grosso' },
            { value: 'MS', label: 'Mato Grosso do Sul' },
            { value: 'MG', label: 'Minas Gerais' },
            { value: 'PA', label: 'Pará' },
            { value: 'PB', label: 'Paraíba' },
            { value: 'PR', label: 'Paraná' },
            { value: 'PE', label: 'Pernambuco' },
            { value: 'PI', label: 'Piauí' },
            { value: 'RJ', label: 'Rio de Janeiro' },
            { value: 'RN', label: 'Rio Grande do Norte' },
            { value: 'RS', label: 'Rio Grande do Sul' },
            { value: 'RO', label: 'Rondônia' },
            { value: 'RR', label: 'Roraima' },
            { value: 'SC', label: 'Santa Catarina' },
            { value: 'SP', label: 'São Paulo' },
            { value: 'SE', label: 'Sergipe' },
            { value: 'TO', label: 'Tocantins' },
        ];

        return estados_list.reduce((acc, estadoRegistro) => {
            const estado = estadosBrasileiros.find(
                est => est.value === estadoRegistro.uf
            );

            if (estado) {
                acc[estado.value] = estado.label;
            }
            return acc;
        }, {});
    };

    carregarEstados = async (inputValue = '') => {
        try {
            const estadosBrasileiros = [
                { value: 'AC', label: 'Acre' },
                { value: 'AL', label: 'Alagoas' },
                { value: 'AM', label: 'Amazonas' },
                { value: 'AP', label: 'Amapá' },
                { value: 'BA', label: 'Bahia' },
                { value: 'CE', label: 'Ceará' },
                { value: 'DF', label: 'Distrito Federal' },
                { value: 'ES', label: 'Espírito Santo' },
                { value: 'GO', label: 'Goiás' },
                { value: 'MA', label: 'Maranhão' },
                { value: 'MT', label: 'Mato Grosso' },
                { value: 'MS', label: 'Mato Grosso do Sul' },
                { value: 'MG', label: 'Minas Gerais' },
                { value: 'PA', label: 'Pará' },
                { value: 'PB', label: 'Paraíba' },
                { value: 'PR', label: 'Paraná' },
                { value: 'PE', label: 'Pernambuco' },
                { value: 'PI', label: 'Piauí' },
                { value: 'RJ', label: 'Rio de Janeiro' },
                { value: 'RN', label: 'Rio Grande do Norte' },
                { value: 'RS', label: 'Rio Grande do Sul' },
                { value: 'RO', label: 'Rondônia' },
                { value: 'RR', label: 'Roraima' },
                { value: 'SC', label: 'Santa Catarina' },
                { value: 'SP', label: 'São Paulo' },
                { value: 'SE', label: 'Sergipe' },
                { value: 'TO', label: 'Tocantins' },
            ];

            if (!inputValue) {
                return estadosBrasileiros;
            }

            return estadosBrasileiros.filter(estado =>
                estado.label.toLowerCase().includes(inputValue.toLowerCase())
            );
        } catch (error) {
            console.error('Erro ao carregar estados:', error);
            return [];
        }
    };

    handleChangeEstadoRegister = (indexChild, campo, value) => {
        this.setState(prevState => ({
            estados_register: prevState.estados_register.map((estado, idx) =>
                idx === indexChild ? { ...estado, [campo]: value } : estado
            )
        }));
    };

    renderRows = () => {
        if ('results' in this.state.listServicoProcedimento && this.state.listServicoProcedimento.results.length > 0) {
            return this.state.listServicoProcedimento.results.map((item) => (
                <tr key={item.id}>
                    <td>{item.servico_procedimento_id}</td>
                    <td>
                        {item.dados_servico.nome}
                        {hasPerm('add_servicos_procedimentos') && (
                            <a
                                href={`/servicos/edit/${item.servico_procedimento_id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title="Abrir cadastro do serviço/procedimento"
                                className="ms-2 text-muted"
                            >
                                <FaEye />
                            </a>
                        )}
                    </td>
                    <td>{item.limite_por_cpf}</td>
                    <td>{item.permite_ultrapassar_limite ? 'Sim' : 'Não'}</td>
                    <td>{item.lembrete_dia_anterior ? 'Sim' : 'Não'}</td>
                    <td>{item.limite_reagendamentos}</td>
                    <td>
                        {item.estados_selecionados
                            ? Object.values(item.estados_selecionados).join(', ')
                            : '-'}
                    </td>
                    <td>
                        <Button  variant="light"  size="sm"  className="me-1" onClick={() => this.abrirModalEditar(item)} >
                            <FaRegEdit /> Editar
                        </Button>
                        <Button variant="outline-danger"  size="sm" onClick={() => this.excluir(item)}>
                            <FaTimes className="me-1"/> Remover Serviço
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={8}>Nenhum Serviço/Procedimento recorrente cadastrada para este programa</td>
            </tr>
        );
    };

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            listServicoProcedimento,
            page_numb,
            showModal,
            modalTitulo,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Serviços/Procedimentos</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovo}>
                                    <FaPlus /> Adicionar Serviço/Procedimento
                                </Button>
                            </Col>
                        </Row>

                        <Row className="align-items-center mb-3">
                            <Col sm={6} xs={12}>
                                <Form method="get" onSubmit={this.filtrarServico}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Filtrar por Serviço/Procedimento:</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="filtro_servico_procedimento"
                                            placeholder="Digite o nome do serviço/procedimento..."
                                            value={this.state.filtro_servico_procedimento}
                                            onChange={(e) => this.setState({ filtro_servico_procedimento: e.target.value })}
                                        />
                                    </Form.Group>
                                    <Button type="submit" variant="secondary" size="sm" className="mb-3">
                                        <FaSearch /> Filtrar
                                    </Button>
                                    <Button type="button" variant="light" size="sm" className="mb-3 ms-1" onClick={this.limpaFiltro}>
                                        <FaEraser /> Limpar Filtro
                                    </Button>
                                </Form>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID Serviço</th>
                                    <th>Serviço</th>
                                    <th>Limite por CPF</th>
                                    <th>Permite ultrapassar limite</th>
                                    <th>Lembrete dia anterior</th>
                                    <th>Limite Reagendamentos</th>
                                    <th>Estados</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={8}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={8}>{error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {'results' in listServicoProcedimento && listServicoProcedimento.results.length > 0 && 
                            <Paginacao 
                                dados={listServicoProcedimento} 
                                loading={loading} 
                                page_numb={page_numb} 
                                _onClickPagina={this.onClickPagina} 
                            />
                        }
                    </Card.Body>
                </Card>

                {/* Modal Cadastro/Edição */}
                <Modal show={showModal}  onHide={this.fecharModal} size="xl" backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                        <Modal.Body>
                            <Form>
                                <Row>
                                    <Col sm={9}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Serviço</Form.Label>
                                            <AsyncSelect
                                                cacheOptions
                                                loadOptions={this.carregarServicos}
                                                defaultOptions
                                                placeholder="Buscar serviço/procedimento..."
                                                onChange={(e) => this.setState({servico_procedimento_id: e.value, servico_procedimento_nome: e.label})}
                                                value={
                                                    this.state.servico_procedimento_id ? {value: this.state.servico_procedimento_id, label: this.state.servico_procedimento_nome} : null 
                                                }
                                            />
                                        </Form.Group>
                                    </Col>

                                     {/*<Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Valor</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="valor"
                                                value={servico.valor} 
                                                onChange={e => this.handleChangeServico(index, e, 'valor')}
                                            />
                                        </Form.Group>
                                    </Col>*/}

                                    <Col sm={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Limite por CPF</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="limite_por_cpf"
                                                value={this.state.limite_por_cpf}
                                                onChange={this.handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Observação do Limite</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="limite_observacao"
                                                value={this.state.limite_observacao}
                                                onChange={this.handleChange}
                                                placeholder="Ex: Somente são permitidos 8 agendamentos por mês"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Permite ultrapassar limite</Form.Label>
                                            <Form.Select
                                                value={this.state.permite_ultrapassar_limite ? 'true' : 'false'}
                                                onChange={e =>
                                                    this.setState({ permite_ultrapassar_limite: e.target.value === 'true' })
                                                }
                                            >
                                                <option value="false">Não</option>
                                                <option value="true">Sim</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Lembrete dia anterior</Form.Label>
                                            <Form.Select
                                                value={this.state.lembrete_dia_anterior ? 'true' : 'false'}
                                                onChange={e =>
                                                    this.setState({ lembrete_dia_anterior: e.target.value === 'true' })
                                                }
                                            >
                                                <option value="false">Não</option>
                                                <option value="true">Sim</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col sm={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Template WhatsApp Prestador</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="template_whatsapp_prestador"
                                                value={this.state.template_whatsapp_prestador || ''} 
                                                onChange={this.handleChange}
                                                placeholder="Nome do template"
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col sm={3}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Template WhatsApp Paciente</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="template_whatsapp_paciente"
                                                value={this.state.template_whatsapp_paciente || ''} 
                                                onChange={this.handleChange}
                                                placeholder="Nome do template"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Limite Reagendamentos</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="limite_reagendamentos"
                                                value={this.state.limite_reagendamentos}
                                                onChange={this.handleChange}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col sm={2}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Limite Período (dias)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                name="limite_periodo"
                                                value={this.state.limite_periodo || ''} 
                                                onChange={this.handleChange}
                                                
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col sm={9}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Estados</Form.Label>
                                            <AsyncSelect
                                                isMulti
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={this.carregarEstados}
                                                placeholder="Buscar estados..."
                                                onChange={(estados) => {
                                                    const selecionados = {};
                                                    const register = [];

                                                    estados.forEach(e => {
                                                        selecionados[e.value] = e.label;
                                                        register.push({
                                                            uf: e.value,
                                                            novo: false,
                                                            novo_acm: false,
                                                            adequacao: false,
                                                            adequacao_acm: false,
                                                            renovacao: false,
                                                            renovacao_acm: false
                                                        });
                                                    });

                                                    this.setState({
                                                        estados_selecionados: selecionados,
                                                        estados_register: register
                                                    });
                                                }}
                                                value={Object.keys(this.state.estados_selecionados).map(uf => ({
                                                    value: uf,
                                                    label: this.state.estados_selecionados[uf]
                                                }))}
                                            />
                                        </Form.Group>
                                    </Col>

                                    {Object.keys(this.state.estados_selecionados).length > 0 && (
                                        <Row>
                                            <Col sm={12} className="divestados">
                                                {Object.entries(this.state.estados_selecionados).map(([sigla, nome]) => (
                                                    <Card className="cardDestaque mb-3" key={sigla}>
                                                        <Card.Body>
                                                            <h5>Opções do estado: {nome} ({sigla})</h5>

                                                            {this.state.estados_register
                                                                .filter(estado => estado.uf === sigla)
                                                                .map((estado, idx) => (
                                                                    <Row key={idx}>
                                                                        <Col sm={2}>
                                                                            <Form.Group>
                                                                                <Form.Label>Novo</Form.Label><br />
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={estado.novo ? "success" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'novo', true)}
                                                                                >
                                                                                    Sim
                                                                                </Button>{' '}
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={!estado.novo ? "danger" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'novo', false)}
                                                                                >
                                                                                    Não
                                                                                </Button>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={2}>
                                                                            <Form.Group>
                                                                                <Form.Label>Novo ACM</Form.Label><br />
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={estado.novo_acm ? "success" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'novo_acm', true)}
                                                                                >
                                                                                    Sim
                                                                                </Button>{' '}
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={!estado.novo_acm ? "danger" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'novo_acm', false)}
                                                                                >
                                                                                    Não
                                                                                </Button>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={2}>
                                                                            <Form.Group>
                                                                                <Form.Label>Adequação</Form.Label><br />
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={estado.adequacao ? "success" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'adequacao', true)}
                                                                                >
                                                                                    Sim
                                                                                </Button>{' '}
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={!estado.adequacao ? "danger" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'adequacao', false)}
                                                                                >
                                                                                    Não
                                                                                </Button>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={2}>
                                                                            <Form.Group>
                                                                                <Form.Label>Adequação ACM</Form.Label><br />
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={estado.adequacao_acm ? "success" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'adequacao_acm', true)}
                                                                                >
                                                                                    Sim
                                                                                </Button>{' '}
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={!estado.adequacao_acm ? "danger" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'adequacao_acm', false)}
                                                                                >
                                                                                    Não
                                                                                </Button>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={2}>
                                                                            <Form.Group>
                                                                                <Form.Label>Renovação</Form.Label><br />
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={estado.renovacao ? "success" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'renovacao', true)}
                                                                                >
                                                                                    Sim
                                                                                </Button>{' '}
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={!estado.renovacao ? "danger" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'renovacao', false)}
                                                                                >
                                                                                    Não
                                                                                </Button>
                                                                            </Form.Group>
                                                                        </Col>

                                                                        <Col sm={2}>
                                                                            <Form.Group>
                                                                                <Form.Label>Renovação ACM</Form.Label><br />
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={estado.renovacao_acm ? "success" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'renovacao_acm', true)}
                                                                                >
                                                                                    Sim
                                                                                </Button>{' '}
                                                                                <Button
                                                                                    size="sm"
                                                                                    variant={!estado.renovacao_acm ? "danger" : "outline-secondary"}
                                                                                    onClick={() => this.handleChangeEstadoRegister(idx, 'renovacao_acm', false)}
                                                                                >
                                                                                    Não
                                                                                </Button>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </Row>
                                                                ))}
                                                        </Card.Body>
                                                    </Card>
                                                ))}
                                            </Col>
                                        </Row>
                                    )}
                                </Row>
                            </Form>
                        </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModal}>
                            Cancelar
                        </Button>
                        <Button  variant="success" onClick={this.salvarServicoProcedimento} disabled={loadingModal}>
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ProgramaServicoProcedimento;